export default __webpack_public_path__ + "static/media/stonehenge.5f7a8cab.svg";